import React from 'react';
import { MDText } from 'i18n-react';
import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { AssetShape } from './shapes';
import { DEFAULT_ASSET_STATUS_COLOR } from './consts';
import EntityPickerItem from '../../EntityPickerItem';

import './style/_AssetEntityPickerItem.scss';

/**
 * A component rendering Asset entity picker item.
 * @param entity
 * @param rest
 * @returns {*}
 * @constructor
 */
const AssetEntityPickerItem = ({ entity, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return (
    <EntityPickerItem
      className="AssetEntityPickerItem"
      entityType={ENTITY_TYPES.ASSET}
      id={entity.id}
      title={entity.clientAssetId}
      statusColor={`status-${entity.status ? entity.status.color : DEFAULT_ASSET_STATUS_COLOR}`}
      statusText={entity.status ? entity.status.label : T.translate('DEFAULT_ASSET_STATUS_LABEL')}
      {...rest}
    />
  );
};

AssetEntityPickerItem.propTypes = {
  /**
   * The issue entity we need to render.
   */
  entity: AssetShape.isRequired
};

export default AssetEntityPickerItem;
